import React from 'react';
import { Offices } from 'components/offices/Offices';
import { OfficesItem } from 'components/offices/OfficesItem';

export const Component = () => {
  return (
    <Offices
      isSlice
      title="Four centers across Europe"
      image={{ url: 'https://picsum.photos/id/972/1200/750', width: 1200, height: 750 }}
    >
      <OfficesItem
        title="HQ in Reykjavik, Iceland"
        text={
          <p>
            Manufacturing, QA/QC, Development support, Finance, Business development, Human
            resources, Technical Operations
          </p>
        }
        address={
          <div>
            <p>Alvotech hf.</p>
            <p>Saemundargata 15-19</p>
            <p>101 Reykjavik</p>
            <p>Iceland</p>
          </div>
        }
        phone="+354 - 522 2900"
      />
      <OfficesItem
        title="Zürich, Switzerland"
        text={
          <p>
            Clinical Development &amp; RA Clinical Development &amp; operations Regulatory affairs,
            Intellectual Property
          </p>
        }
        address={
          <div>
            <p>Alvotech Swiss AG</p>
            <p>Thurgauerstrasse 54</p>
            <p>CH-8050 Zürich</p>
            <p>Switzerland</p>
          </div>
        }
        phone="+41 78 659 89 89"
      />
      <OfficesItem
        title="Hannover, Germany"
        text={
          <p>State-of-the art Glyco-analysis capacity Protein characterization and analytics</p>
        }
        address={
          <div>
            <p>Glycothera GMBH</p>
            <p>Feodor Lynen Str. 35</p>
            <p>30625 Hannover</p>
            <p>Germany</p>
          </div>
        }
        phone="+49 511 978 199 0"
      />
      <OfficesItem
        title="Jülich, Germany"
        text={
          <p>
            Cell line and process development, Method development and analytics, Preclinical
            development, Project management, R&amp;D activities
          </p>
        }
        address={
          <div>
            <p>Alvotech Germany GmbH</p>
            <p>Karl-Heinz-Beckurts-Str. 13</p>
            <p>52428 Jülich</p>
            <p>Germany</p>
          </div>
        }
        phone="+49 - (0)2461 - 690576"
        fax="+49 - (0)2461 - 690579"
      />
    </Offices>
  );
};
